// extracted by mini-css-extract-plugin
export default {"container":"NoInternet_container__Gfzy6","main":"NoInternet_main__2lgmh","img":"NoInternet_img__kdbLr","header":"NoInternet_header__szaCj","text":"NoInternet_text__ZN5Iw"};